function Core6Boot() {


  this.startParallax = function () {
    //console.log("starting parallax");
    $('.parallax-window').parallax();
  };

  this.startPropertySearch = function () {
    var that = this;
    var profile_type = $('input[name=profile_type]');
    if (!profile_type) {
      return true;
    }

    var leasing = $('.leasing_field'),
        sales = $('.sales_field'),
        profile_type_selected = $('input[name=profile_type]:checked');

    if (profile_type_selected.val() == "lettings") {
      //console.log('property search toggled: lettings');
      sales.css('display', 'none');
      leasing.css('display', 'block');
    } else {
      //console.log('property search toggled: sales');
      leasing.css('display', 'none');
      sales.css('display', 'block');
    }

    //console.log('initialising property search');
    profile_type.on('change', function () {
      var leasing = $('.leasing_field'),
          sales = $('.sales_field'),
          profile_type_selected = $('input[name=profile_type]:checked');

      if (profile_type_selected.val() == "lettings") {
        //console.log('property search toggled: lettings');
        sales.css('display', 'none');
        leasing.css('display', 'block');
      } else {
        //console.log('property search toggled: sales');
        leasing.css('display', 'none');
        sales.css('display', 'block');
      }
    });
  };
}

self.Core6Booter = new Core6Boot();
Core6Booter.startPropertySearch();


// WEBPACK FOOTER //
// ./resources/assets/js/core6/public_boot.js